import { PayloadAction } from "@reduxjs/toolkit";
import { CartSliceState, CartType } from "../types";

export const selectionReducers = {
  setSelectedProdIds: (
    state: CartSliceState,
    action: PayloadAction<string>,
  ) => {
    if (state.selectedProdItems.includes(action.payload)) {
      state.selectedProdItems = state.selectedProdItems.filter(
        (id) => id !== action.payload,
      );
    } else {
      state.selectedProdItems.push(action.payload);
    }
  },

  setSelectedRemainsIds: (
    state: CartSliceState,
    action: PayloadAction<string>,
  ) => {
    if (state.selectedRemainsItems.includes(action.payload)) {
      state.selectedRemainsItems = state.selectedRemainsItems.filter(
        (id) => id !== action.payload,
      );
    } else {
      state.selectedRemainsItems.push(action.payload);
    }
  },
  setSelectedAllRows: (
    state: CartSliceState,
    action: PayloadAction<{ data: string[]; type: CartType }>,
  ) => {
    const { data, type } = action.payload;
    const stateValue =
      type === "production" ? state.allProdIds : state.allRemainsIds;
    const check = data.length === stateValue.length;

    if (check) {
      type === "production"
        ? (state.selectedProdItems = [])
        : (state.selectedRemainsItems = []);
    } else {
      type === "production"
        ? (state.selectedProdItems = state.allProdIds)
        : (state.selectedRemainsItems = state.allRemainsIds);
    }
  },
  setSelectedAllDealerRows: (
    state: CartSliceState,
    action: PayloadAction<{ data: string[]; type: CartType }>,
  ) => {
    const { data, type } = action.payload;
    const stateValue =
      type === "production"
        ? state.allBasketProdIds
        : state.allBasketRemainsIds;
    const check = data.length === stateValue.length;

    if (check) {
      type === "production"
        ? (state.selectedProdItems = [])
        : (state.selectedRemainsItems = []);
    } else {
      type === "production"
        ? (state.selectedProdItems = state.allBasketProdIds)
        : (state.selectedRemainsItems = state.allBasketRemainsIds);
    }
  },
  // Переключает выбор набора basketId: если выбраны все — снимает, иначе добавляет
  toggleDealerRemainsBasketIds: (
    state: CartSliceState,
    action: PayloadAction<string[]>,
  ) => {
    const ids = action.payload;
    const selected = state.selectedDealerRemainsBasketIds;
    const allSelected = ids.every((id) => selected.includes(id));
    state.selectedDealerRemainsBasketIds = allSelected
      ? selected.filter((id) => !ids.includes(id))
      : [...new Set([...selected, ...ids])];
  },
  setDeleteMode: (state: CartSliceState, action: PayloadAction<boolean>) => {
    state.deleteMode = action.payload;
    if (!action.payload) {
      state.selectedProdItems = [];
      state.selectedRemainsItems = [];
      state.selectedDealerRemainsBasketIds = [];
    }
  },
};
